<template>
  <div v-loading="loading">
    <a-page-header
      @back="()=>$router.go(-1)"
      :title="`${isEdit ? '编辑' : '新增'}填报数据`"
      style="padding-left: 0; margin-bottom: 10px; border-bottom: 1px solid rgb(235, 237, 240)"
    />
    <div class="">
      <a-form :label-col="{span: 12}" :wrapper-col="{span: 12}">
        <a-row :gutter="20">
          <a-col :span="24">
            <a-form-item :label-col="{span: 2}" :wrapper-col="{span: 22}" label="标题">
              <a-input v-model.trim="form.title" :maxLength="30" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="企业总数">
              <a-input v-model.trim="form.enterpriseTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="企业面积">
              <a-input v-model.trim="form.industryArea" placeholder="" />
            </a-form-item>
          </a-col>
        </a-row>
        <div class="table-group">
          <div class="pub-flex flex-jc-stretch pb-gap-10">
            <span>产业分布数据</span>
            <a-button class="btnClass" @click="showOptionForm('industryDistribution')" type="primary" size="small">新增</a-button>
          </div>
          <a-table :columns="industryDistributionColumn" :data-source="form.industryDistribution" :pagination="false" bordered>
            <div slot="action" slot-scope="text, record, index">
              <a-button class="btnClass" @click="editRecord(record, index, 'industryDistribution')" type="link">编辑</a-button>
              <a-button class="btnClass" @click="deleteOption(record, index, 'industryDistribution')" type="link">删除</a-button>
            </div>
          </a-table>
        </div>
        <a-row :gutter="20" class="mt-gap-10">
          <a-col :span="8">
            <a-form-item label="荣誉资质数量">
              <a-input v-model.trim="form.honorQualificationTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="上市公司数量">
              <a-input v-model.trim="form.listedEnterpriseTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="国家高新技术企业数量">
              <a-input v-model.trim="form.nationalHighTechEnterpriseTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="专精特新小巨人数量">
              <a-input v-model.trim="form.specializedLittleGiantTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="科技型中小企业数量">
              <a-input v-model.trim="form.techSmeTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="专精特新中小企业数量">
              <a-input v-model.trim="form.specializedSmeTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="有融资企业数量">
              <a-input v-model.trim="form.financedEnterpriseTotal" placeholder="" />
            </a-form-item>
          </a-col>
        </a-row>
        <div class="table-group">
          <div class="pub-flex flex-jc-stretch pb-gap-10">
            <span>融资轮次分布</span>
            <a-button class="btnClass" @click="showOptionForm('financingRoundDistribution')" type="primary" size="small">新增</a-button>
          </div>
          <a-table :columns="financingRoundDistributionColumn" :data-source="form.financingRoundDistribution" :pagination="false" bordered>
            <div slot="action" slot-scope="text, record, index">
              <a-button class="btnClass" @click="editRecord(record, index, 'financingRoundDistribution')" type="link">编辑</a-button>
              <a-button class="btnClass" @click="deleteOption(record, index, 'financingRoundDistribution')" type="link">删除</a-button>
            </div>
          </a-table>
        </div>
        <a-row :gutter="20" class="mt-gap-10">
          <a-col :span="8">
            <a-form-item label="知识产权总数量">
              <a-input v-model.trim="form.intellectualPropertyTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="专利数量">
              <a-input v-model.trim="form.patentTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="软件著作数量">
              <a-input v-model.trim="form.softwareCopyrightTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="作品著作数量">
              <a-input v-model.trim="form.workCopyrightTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="商标数量">
              <a-input v-model.trim="form.trademarkTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="项目累计招募数量">
              <a-input v-model.trim="form.recruitmentTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="项目今年招募数量">
              <a-input v-model.trim="form.currentYearRecruitmentTotal" placeholder="" />
            </a-form-item>
          </a-col>
        </a-row>
        <div class="table-group">
          <div class="pub-flex flex-jc-stretch pb-gap-10">
            <span>每年招募趋势</span>
            <a-button class="btnClass" @click="showOptionForm('annualRecruitmentTrend')" type="primary" size="small">新增</a-button>
          </div>
          <a-table :columns="annualRecruitmentTrendColumn" :data-source="form.annualRecruitmentTrend" :pagination="false" bordered>
            <div slot="action" slot-scope="text, record, index">
              <a-button class="btnClass" @click="editRecord(record, index, 'annualRecruitmentTrend')" type="link">编辑</a-button>
              <a-button class="btnClass" @click="deleteOption(record, index, 'annualRecruitmentTrend')" type="link">删除</a-button>
            </div>
          </a-table>
        </div>
        <div class="table-group mt-gap-10">
          <div class="pub-flex flex-jc-stretch pb-gap-10">
            <span>项目产业分布</span>
            <a-button class="btnClass" @click="showOptionForm('projectIndustryDistribution')" type="primary" size="small">新增</a-button>
          </div>
          <a-table :columns="projectIndustryDistributionColumn" :data-source="form.projectIndustryDistribution" :pagination="false" bordered>
            <div slot="action" slot-scope="text, record, index">
              <a-button class="btnClass" @click="editRecord(record, index, 'projectIndustryDistribution')" type="link">编辑</a-button>
              <a-button class="btnClass" @click="deleteOption(record, index, 'projectIndustryDistribution')" type="link">删除</a-button>
            </div>
          </a-table>
        </div>
        <a-row :gutter="20" class="mt-gap-10">
          <a-col :span="8">
            <a-form-item label="班车线路数量">
              <a-input v-model.trim="form.busRouteTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="每日班次数量">
              <a-input v-model.trim="form.dailyBusTripTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="社群数量">
              <a-input v-model.trim="form.communityTotal" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="社群人数">
              <a-input v-model.trim="form.communityMemberTotal" placeholder="" />
            </a-form-item>
          </a-col>
        </a-row>
        <div class="table-group">
          <div class="pub-flex flex-jc-stretch pb-gap-10">
            <span>活跃社群 TOP5</span>
            <a-button class="btnClass" @click="showOptionForm('activeCommunityTop5', true, 5)" type="primary" size="small">新增</a-button>
          </div>
          <a-table :columns="activeCommunityTop5Column" :data-source="form.activeCommunityTop5" :pagination="false" bordered>
            <div slot="action" slot-scope="text, record, index">
              <a-button class="btnClass" @click="editRecord(record, index, 'activeCommunityTop5')" type="link">编辑</a-button>
              <a-button class="btnClass" @click="deleteOption(record, index, 'activeCommunityTop5')" type="link">删除</a-button>
            </div>
          </a-table>
        </div>
        <a-row :gutter="20" class="mt-gap-10">
          <a-col :span="8">
            <a-form-item label="孵化落地企业数量">
              <a-input v-model.trim="form.incubationLandingEnterpriseTotal" placeholder="" />
            </a-form-item>
          </a-col>
        </a-row>
        <div class="table-group">
          <div class="pub-flex flex-jc-stretch pb-gap-10">
            <span>孵化落地企业</span>
            <a-button class="btnClass" @click="showIncubatedEnterpriseForm" type="primary" size="small">新增</a-button>
          </div>
          <a-table :columns="incubatedEnterpriseColumn" :data-source="form.incubationLandingEnterpriseList || []" :pagination="false" bordered>
            <div slot="action" slot-scope="text, record, index">
              <a-button class="btnClass" @click="editIncubatedEnterprise(record, index)" type="link">编辑</a-button>
              <a-button class="btnClass" @click="deleteIncubatedEnterprise(index)" type="link">删除</a-button>
            </div>
          </a-table>
        </div>
        <a-row :gutter="20" class="mt-gap-10">
          <a-col :span="8">
            <a-form-item label="已入住房源数">
              <a-input v-model.trim="form.settledHouseTotal" placeholder="" />
            </a-form-item>
          </a-col>
        </a-row>
        <div class="table-group">
          <div class="pub-flex flex-jc-stretch pb-gap-10">
            <span>房源分布</span>
            <a-button class="btnClass" @click="showOptionForm('houseCategoryDistribution')" type="primary" size="small">新增</a-button>
          </div>
          <a-table :columns="houseCategoryDistributionColumn" :data-source="form.houseCategoryDistribution || []" :pagination="false" bordered>
            <div slot="action" slot-scope="text, record, index">
              <a-button class="btnClass" @click="editRecord(record, index, 'houseCategoryDistribution')" type="link">编辑</a-button>
              <a-button class="btnClass" @click="deleteOption(record, index, 'houseCategoryDistribution')" type="link">删除</a-button>
            </div>
          </a-table>
        </div>
        <div class="text-center mt-gap-10">
          <a-button class="btnClass" type="primary" @click="saveForm">提交</a-button>
        </div>
      </a-form>
    </div>
    <a-modal
      :title="dynamicEditFormTitle"
      :visible="optionFormVisible"
      @ok="handleOk"
      @cancel="optionFormVisible = false"
    >
      <a-form-model 
        ref="optionFormRef" 
        :model="optionForm" 
        :rules="optionFormRules" 
        :label-col="{span:4}" 
        :wrapper-col="{span:20}"
      >
        <a-form-model-item :label="activeFormTitleLabel" prop="key">
          <a-input v-model.trim="optionForm.key" />
        </a-form-model-item>
        <a-form-model-item :label="activeFormValueLabel" prop="value">
          <a-input v-model.trim="optionForm.value" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal
      :title="incubatedEnterpriseModalTitle"
      :visible="incubatedEnterpriseFormVisible"
      @ok="handleIncubatedEnterpriseOk"
      @cancel="incubatedEnterpriseFormVisible = false"
    >
      <a-form-model
        ref="incubatedEnterpriseFormRef"
        :model="incubatedEnterpriseForm"
        :rules="incubatedEnterpriseFormRules"
        :label-col="{span:4}"
        :wrapper-col="{span:20}"
      >
        <a-form-model-item label="企业名称" prop="enterpriseName">
          <a-input v-model.trim="incubatedEnterpriseForm.enterpriseName" :maxLength="50" placeholder="请输入企业名称" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import * as api from "@/api/dataAnalysis/dataSubForm.js";
export default {
  components: {

  },
  props: {
      
  },
  computed: {
    activeFormTitleLabel(){
      return this.dynamicFormTitleMaps[this.actionAttr] || "";
    },
    activeFormValueLabel(){
      return this.dynamicFormValueMaps[this.actionAttr] || "";
    }
  },
  watch: {
    optionFormVisible(newVal, oldVal){
      if(!newVal){
        this.optionForm = {key: "",value: ""};
        this.actionType = null;
      }else{
        this.$nextTick(()=>{
          this.$refs["optionFormRef"].clearValidate();
        })
      }
    },
    incubatedEnterpriseFormVisible(newVal){
      if(!newVal){
        this.incubatedEnterpriseForm = { enterpriseName: "" };
        this.incubatedEnterpriseEditMode = false;
        this.incubatedEnterpriseEditIdx = -1;
      }else{
        this.$nextTick(()=>{
          this.$refs["incubatedEnterpriseFormRef"] && this.$refs["incubatedEnterpriseFormRef"].clearValidate();
        })
      }
    }
  },
  data() {
      return {
        dynamicEditFormTitle: "",
        dynamicFormTitleMaps: {
          "industryDistribution": "产业名称",
          "financingRoundDistribution": "融资轮次",
          "annualRecruitmentTrend": "年份",
          "projectIndustryDistribution": "产业名称",
          "activeCommunityTop5": "社群名称",
          "houseCategoryDistribution": "分类名称",
          "-":"-",
        },
        dynamicFormValueMaps: {
          "industryDistribution": "展示值",
          "financingRoundDistribution": "展示值",
          "annualRecruitmentTrend": "招募数量",
          "projectIndustryDistribution": "展示值",
          "activeCommunityTop5": "展示值",
          "houseCategoryDistribution": "展示值",
          "-":"-",
        },
        isEdit: this.$route.query.id ? true : false,
        loading: false,
        form: {
          title: "",
          enterpriseTotal: "",
          industryArea: "",
          industryDistribution: [],
          honorQualificationTotal: "",
          listedEnterpriseTotal: "",
          nationalHighTechEnterpriseTotal: "",
          specializedLittleGiantTotal: "",
          techSmeTotal: "",
          specializedSmeTotal: "",
          financedEnterpriseTotal: "",
          financingRoundDistribution: [],
          intellectualPropertyTotal: "",
          patentTotal: "",
          softwareCopyrightTotal: "",
          workCopyrightTotal: "",
          trademarkTotal: "",
          recruitmentTotal: "",
          currentYearRecruitmentTotal: "",
          annualRecruitmentTrend: [],
          projectIndustryDistribution: [],
          busRouteTotal: "",
          dailyBusTripTotal: "",
          communityTotal: "",
          communityMemberTotal: "",
          activeCommunityTop5: [],
          incubationLandingEnterpriseTotal: "",
          incubationLandingEnterpriseList: [],
          settledHouseTotal: "",
          houseCategoryDistribution: [],
        },
        actionAttr: "-", // 当前显示的是那个表单，ok的时候对应插入
        optionFormVisible: false,
        incubatedEnterpriseFormVisible: false,
        incubatedEnterpriseModalTitle: "新增孵化落地企业",
        incubatedEnterpriseForm: {
          enterpriseName: "",
        },
        incubatedEnterpriseFormRules: {
          enterpriseName: [
            { required: true, message: '请输入企业名称', trigger: 'change' },
            { max: 50, message: '企业名称不能超过50个字符', trigger: 'change' },
          ],
        },
        incubatedEnterpriseEditMode: false,
        incubatedEnterpriseEditIdx: -1,
        industryDistributionColumn: [
          {
            title: '产业名称',
            dataIndex: 'key',
            key: 'key',
            customRender: (text) => text || '-',
          },
          {
            title: '展示值',
            dataIndex: 'value',
            key: 'value',
            customRender: (text) => text || '-',
          },
          {
            title: '操作',
            key: 'action',
            width: '180px',
            scopedSlots: { customRender: 'action' },
          },
        ],
        financingRoundDistributionColumn: [
          {
            title: '融资轮次',
            dataIndex: 'key',
            key: 'key',
            customRender: (text) => text || '-',
          },
          {
            title: '展示值',
            dataIndex: 'value',
            key: 'value',
            customRender: (text) => text || '-',
          },
          {
            title: '操作',
            key: 'action',
            width: '180px',
            scopedSlots: { customRender: 'action' },
          },
        ],
        annualRecruitmentTrendColumn: [
          {
            title: '年份',
            dataIndex: 'key',
            key: 'key',
            customRender: (text) => text || '-',
          },
          {
            title: '招募数量',
            dataIndex: 'value',
            key: 'value',
            customRender: (text) => text || '-',
          },
          {
            title: '操作',
            key: 'action',
            width: '180px',
            scopedSlots: { customRender: 'action' },
          },
        ],
        projectIndustryDistributionColumn: [
          {
            title: '产业名称',
            dataIndex: 'key',
            key: 'key',
            customRender: (text) => text || '-',
          },
          {
            title: '展示值',
            dataIndex: 'value',
            key: 'value',
            customRender: (text) => text || '-',
          },
          {
            title: '操作',
            key: 'action',
            width: '180px',
            scopedSlots: { customRender: 'action' },
          },
        ],
        activeCommunityTop5Column: [
          {
            title: '社群名称',
            dataIndex: 'key',
            key: 'key',
            customRender: (text) => text || '-',
          },
          {
            title: '展示值',
            dataIndex: 'value',
            key: 'value',
            customRender: (text) => text || '-',
          },
          {
            title: '操作',
            key: 'action',
            width: '180px',
            scopedSlots: { customRender: 'action' },
          },
        ],
        incubatedEnterpriseColumn: [
          {
            title: '企业名称',
            key: 'enterpriseName',
            customRender: (text, record) => record || '-',
          },
          {
            title: '操作',
            key: 'action',
            width: '180px',
            scopedSlots: { customRender: 'action' },
          },
        ],
        houseCategoryDistributionColumn: [
          {
            title: '分类名称',
            dataIndex: 'key',
            key: 'key',
            customRender: (text) => text || '-',
          },
          {
            title: '展示值',
            dataIndex: 'value',
            key: 'value',
            customRender: (text) => text || '-',
          },
          {
            title: '操作',
            key: 'action',
            width: '180px',
            scopedSlots: { customRender: 'action' },
          },
        ],
        optionFormRules: {
          key: [
            { required: true, message: '请输入', trigger: 'change' }
          ],
          value: [
            { required: true, message: '请输入', trigger: 'change' }
          ]
        },
        optionForm: {
          key: "",
          value: "",
        },
        editMode: false,
        editIdx: -1,
      }
  },
  created(){

  },
  mounted(){
    if(this.isEdit){
      this.getDetail();
    }
  },
  methods: {
    editRecord(record, index, attr){
      this.optionForm = {...record};
      this.actionAttr = attr;
      this.editMode = true;
      this.editIdx = index;
      this.optionFormVisible = true;
      this.dynamicEditFormTitle = `编辑${this.getDynamicFormTitle(attr)}`;
    },
    deleteOption(record, index, attr){
      this.$delete(this.form[attr], index);
    },
    showOptionForm(formKey, limit, maxLen){
      if(limit && this.form[formKey].length >= maxLen){
        this.$message.warning(`最多创建${maxLen}条数据`);
        return;
      }
      this.dynamicEditFormTitle = `新增${this.getDynamicFormTitle(formKey)}`;
      this.editMode = false;
      this.actionAttr = formKey;
      this.optionFormVisible = true;
    },
    getDynamicFormTitle(key){
      return {
        industryDistribution: "产业分布数据",
        financingRoundDistribution: "融资轮次分布",
        annualRecruitmentTrend: "每年招募趋势",
        projectIndustryDistribution: "项目产业分布",
        activeCommunityTop5: "活跃社群 TOP5",
        houseCategoryDistribution: "房源分布",
      }[key] || "";
    },
    handleOk(){
      this.$refs["optionFormRef"].validate((valid)=>{
        if(valid){
          if(this.editMode){
            this.$set(this.form[this.actionAttr], this.editIdx, {...this.optionForm});
          }else{
            this.form[this.actionAttr].push({...this.optionForm});
          }
          this.optionFormVisible = false;
        }
      });
    },
    normalizeIncubationLandingEnterpriseList(list){
      if(Array.isArray(list)){
        return list;
      }
      if(typeof list === 'string' && list){
        try {
          const parsed = JSON.parse(list);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }
      return [];
    },
    showIncubatedEnterpriseForm(){
      if(!Array.isArray(this.form.incubationLandingEnterpriseList)){
        this.$set(this.form, 'incubationLandingEnterpriseList', []);
      }
      this.incubatedEnterpriseEditMode = false;
      this.incubatedEnterpriseEditIdx = -1;
      this.incubatedEnterpriseModalTitle = "新增孵化落地企业";
      this.incubatedEnterpriseFormVisible = true;
    },
    editIncubatedEnterprise(record, index){
      this.incubatedEnterpriseForm = { enterpriseName: record || "" };
      this.incubatedEnterpriseEditMode = true;
      this.incubatedEnterpriseEditIdx = index;
      this.incubatedEnterpriseModalTitle = "编辑孵化落地企业";
      this.incubatedEnterpriseFormVisible = true;
    },
    deleteIncubatedEnterprise(index){
      this.$delete(this.form.incubationLandingEnterpriseList, index);
    },
    handleIncubatedEnterpriseOk(){
      this.$refs["incubatedEnterpriseFormRef"].validate((valid)=>{
        if(valid){
          if(!Array.isArray(this.form.incubationLandingEnterpriseList)){
            this.$set(this.form, 'incubationLandingEnterpriseList', []);
          }
          const name = this.incubatedEnterpriseForm.enterpriseName;
          if(this.incubatedEnterpriseEditMode){
            this.$set(this.form.incubationLandingEnterpriseList, this.incubatedEnterpriseEditIdx, name);
          }else{
            this.form.incubationLandingEnterpriseList.push(name);
          }
          this.incubatedEnterpriseFormVisible = false;
        }
      });
    },
    getDetail(){
      this.loading = true;
      return api.getDataDetail({id: this.$route.query.id})
      .finally(()=>{
        this.loading = false;
      })
      .then(({code, data, msg})=>{
        if(code == 200){
          this.$set(this, 'form', {
            ...data,
            incubationLandingEnterpriseTotal: data.incubationLandingEnterpriseTotal || "",
            incubationLandingEnterpriseList: this.normalizeIncubationLandingEnterpriseList(data.incubationLandingEnterpriseList),
            settledHouseTotal: data.settledHouseTotal || "",
            houseCategoryDistribution: Array.isArray(data.houseCategoryDistribution) ? data.houseCategoryDistribution : [],
          });
        }else{
          this.$message.error(msg || "详情获取失败");
        }
      });
    },
    saveForm(){
      if(!this.form.title){
        this.$message.error("请输入标题");
        return
      }
      if(!this.form.houseCategoryDistribution || !this.form.houseCategoryDistribution.length){
        this.$message.error("请至少添加一条房源分布");
        return
      }
      const arrAttrList = [
        "industryDistribution", 
        "financingRoundDistribution", 
        "annualRecruitmentTrend", 
        "projectIndustryDistribution", 
        "activeCommunityTop5",
        "incubationLandingEnterpriseList",
        "houseCategoryDistribution"
      ];
      const emptyForm = {};
      for (const key in this.form) {
        const isArrayKey = arrAttrList.includes(key);
        if(isArrayKey && this.form[key] && this.form[key].length){
          emptyForm[key] = this.form[key];
        }
        if(!isArrayKey && this.form[key]){
          emptyForm[key] = this.form[key];
        }
      }
      console.log("emptyForm", emptyForm);
      this.loading = true;
      if(this.isEdit){
        emptyForm["dashboardFillId"] = this.$route.query.id;
      }
      const promise = this.isEdit ? api.updateData(emptyForm) : api.addData(emptyForm);
      promise.finally(()=>{
        this.loading = false;
      })
      .then(({code, data, msg})=>{
        if(code == 200){
          this.$message.success(msg);
          this.$router.go(-1);
        }else{
          this.$message.error(msg);
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
  .pb-gap-10{
    padding: 0 0 10px;
  }
  .mt-gap-10{
    margin-top: 10px;
  }
  ::v-deep .table-group th{
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  ::v-deep .table-group td{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  ::v-deep .btnClass{
    padding: 0px 4px !important
  }
</style>